// test718
(718 && 0);
